import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function Offer() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const handleBasicAddToCart = () => {
    trackAddToCart(57, 'BRL');
    window.location.href = 'https://artesbr.profepack.com/cart/47447404216569:1';
  };
  return <section id="comprar" className="w-full bg-gray-50 py-8 md:py-20 px-4 md:px-4" data-id="element-89">
      <div className="max-w-2xl mx-auto" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-6 md:mb-10" data-id="element-91">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-2 md:mb-3" data-id="element-92">
            Garanta seu Acesso
          </h2>
          <p className="text-sm md:text-lg text-gray-600" data-id="element-93">
            ⚡ Acesso imediato após o pagamento
          </p>
        </motion.div>

        {/* PLANO AULAS PRONTAS — único, centralizado, otimizado para conversão */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-red-600" data-id="element-94">
          {/* Header banner */}
          <div className="bg-red-700 text-white text-center py-3 px-4" data-id="element-95">
            <p className="font-black text-sm md:text-base tracking-wide uppercase" data-id="element-96">
              🔥 Oferta Especial por Tempo Limitado
            </p>
          </div>

          <div className="p-5 md:p-10" data-id="element-97">
            <div className="text-center mb-5 md:mb-8" data-id="element-98">
              <div className="text-3xl md:text-4xl mb-2" data-id="element-99">🛒</div>
              <h3 className="text-xl md:text-3xl font-black text-gray-900 mb-1 leading-tight" data-id="element-100">
                PLANO AULAS PRONTAS
              </h3>
              <p className="text-sm md:text-base text-gray-600" data-id="element-101">
                Para o professor que quer suas aulas resolvidas
              </p>
            </div>

            {/* Preço */}
            <div className="text-center mb-5 md:mb-8" data-id="element-102">
              <div className="flex items-center justify-center gap-3 mb-1" data-id="element-103">
                <span className="text-base md:text-xl text-gray-400 line-through font-bold" data-id="element-104">
                  R$ 197,00
                </span>
                <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-black" data-id="element-105">
                  -71% OFF
                </span>
              </div>
              <div className="text-5xl md:text-7xl font-black text-gray-900 leading-none" data-id="element-106">
                R$ 57
              </div>
              <p className="text-xs md:text-sm text-gray-500 mt-1" data-id="element-107">
                Pagamento único • Sem mensalidade
              </p>
            </div>

            {/* CTA principal */}
            <motion.button onClick={handleBasicAddToCart} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="w-full bg-red-700 text-white px-6 py-4 md:py-5 rounded-xl font-black text-lg md:text-2xl shadow-xl hover:bg-red-800 transition-all duration-300 mb-3" data-id="element-108">
              ✅ Sim, quero essa oferta!
            </motion.button>

            <div className="flex items-center justify-center gap-2 text-gray-500 text-xs md:text-sm mb-5 md:mb-8" data-id="element-109">
              <ShieldCheckIcon className="h-4 w-4 md:h-5 md:w-5" data-id="element-110" />
              <span data-id="element-111">🔒 Pagamento 100% seguro • 🛡️ Garantia 7 dias</span>
            </div>

            {/* Lista de itens inclusos */}
            <div className="border-t border-gray-200 pt-5 md:pt-8" data-id="element-112">
              <h4 className="font-black text-gray-900 mb-4 text-sm md:text-base uppercase text-center tracking-wide" data-id="element-113">
                O que você recebe hoje:
              </h4>
              <ul className="space-y-2 md:space-y-3" data-id="element-114">
                <li className="flex items-start" data-id="element-115">
                  <CheckIcon className="h-4 w-4 md:h-5 md:w-5 text-green-600 mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-116" />
                  <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-117">
                    ✅ 12 Tomos Digitais Completos (PDF)
                  </span>
                </li>
                <li className="flex items-start" data-id="element-118">
                  <CheckIcon className="h-4 w-4 md:h-5 md:w-5 text-green-600 mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-119" />
                  <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-120">
                    ✅ Bônus #1: Aula de Artes em 10 Minutos
                  </span>
                </li>
                <li className="flex items-start" data-id="element-121">
                  <CheckIcon className="h-4 w-4 md:h-5 md:w-5 text-green-600 mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-122" />
                  <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-123">
                    ✅ Bônus #2: Banco de Avaliação Inteligente
                  </span>
                </li>
                <li className="flex items-start" data-id="element-124">
                  <CheckIcon className="h-4 w-4 md:h-5 md:w-5 text-green-600 mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-125" />
                  <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-126">
                    ✅ Bônus #3: Ateliê Econômico
                  </span>
                </li>
                <li className="flex items-start" data-id="element-127">
                  <CheckIcon className="h-4 w-4 md:h-5 md:w-5 text-green-600 mr-2 md:mr-3 mt-0.5 flex-shrink-0" data-id="element-128" />
                  <span className="text-sm md:text-base text-gray-700 font-medium" data-id="element-129">
                    ✅ Atualizações vitalícias
                  </span>
                </li>
              </ul>
            </div>

            {/* CTA secundário */}
            <motion.button onClick={handleBasicAddToCart} whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} className="w-full bg-red-700 text-white px-6 py-3 md:py-4 rounded-xl font-black text-base md:text-xl shadow-lg hover:bg-red-800 transition-all duration-300 mt-6" data-id="element-130">
              🎨 Quero o Mega Pacote Agora!
            </motion.button>

            <p className="text-center text-xs text-gray-400 mt-3" data-id="element-131">
              ✉️ Entrega imediata por e-mail após o pagamento
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center mt-4" data-id="element-132">
          <p className="text-xs md:text-sm text-gray-500" data-id="element-133">
            🛡️ Garantia incondicional de 7 dias • Acesso imediato
          </p>
        </motion.div>
      </div>
    </section>;
}